var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGisProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 72,
    viewBox: "0 0 85 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3381",
    "data-name": "Rectangle 3381",
    width: 51.514,
    height: 56.17,
    fill: "#5e84c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14404",
    "data-name": "Group 14404",
    transform: "translate(-525 -1119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14403",
    "data-name": "Group 14403",
    transform: "translate(-443 227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14355",
    "data-name": "Group 14355",
    transform: "translate(514 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(454 887)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14402",
    "data-name": "Group 14402",
    transform: "translate(-393 227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14363",
    "data-name": "Group 14363",
    transform: "translate(-11 -394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3382",
    "data-name": "Rectangle 3382",
    transform: "translate(950 1294)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14362",
    "data-name": "Group 14362",
    transform: "translate(945 903.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14361",
    "data-name": "Group 14361",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42153",
    "data-name": "Path 42153",
    d: "M81.761,0a30.115,30.115,0,0,1,3.148.667c6.5,2.093,10.364,6.551,11.632,13.245.6,3.169-.24,6.115-1.556,8.967A56.621,56.621,0,0,1,88.505,33.4c-2.013,2.645-4.145,5.2-6.268,7.76a2.316,2.316,0,0,1-3.812,0A93.363,93.363,0,0,1,67.174,25.8a29.61,29.61,0,0,1-2.708-6.146,13.507,13.507,0,0,1,.576-9.115A16.184,16.184,0,0,1,78.051.143c.286-.05.572-.1.858-.143ZM80.307,25.731a9.356,9.356,0,1,0-9.324-9.746,9.365,9.365,0,0,0,9.324,9.746",
    transform: "translate(-54.575)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42154",
    "data-name": "Path 42154",
    d: "M25.211,250.857q-11.749-5.868-23.5-11.731a2.776,2.776,0,0,1-1.584-1.571,2.35,2.35,0,0,1,1.315-2.911q3.522-1.769,7.051-3.525l6.15-3.071c.713.959,1.389,1.934,2.134,2.854q2.672,3.3,5.4,6.559a4.677,4.677,0,0,0,7.156.011q2.731-3.253,5.4-6.558c.745-.92,1.421-1.9,2.146-2.87l5.058,2.528Q46,232.6,50.068,234.64a2.328,2.328,0,0,1,1.352,2.8,2.481,2.481,0,0,1-1.41,1.581q-5.907,2.942-11.8,5.9-5.412,2.707-10.827,5.41c-.355.177-.714.349-1.071.523Z",
    transform: "translate(0 -194.687)",
    fill: "#5e84c3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGisProfile);
export default __webpack_public_path__ + "static/media/gis-profile.1219df17e0e0a567105ee315a7048168.svg";
export { ForwardRef as ReactComponent };